import React, { useState } from "react";
import Sidebar from "../components/common/Sidebar";
import AuthNavbar from "../components/common/AuthNavbar";

const DashboardLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <React.Fragment>
      {/* Fixed Navigation Bar */}
      <AuthNavbar
        setIsSidebarOpen={setIsSidebarOpen}
        isSidebarOpen={isSidebarOpen}
      />

      {/* Sidebar Component */}
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
      />

      {/* Main Content Area */}
      <div className="min-h-screen bg-gray-50">
        <div className="lg:pl-60 pt-16">
          <main className="min-h-screen">
            {/* Content padding and scrollable area */}
            <div className="max-w-full">
              {children}
            </div>
          </main>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DashboardLayout;
